import PropTypes from 'prop-types';
import { Skeleton, Box, Typography } from '@mui/material';
import { AppChartCard } from '../@dashboard/app';

StateOfChargeChart.propTypes = {
  site: PropTypes.object.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  series: PropTypes.array,
  loading: PropTypes.bool,
  hasData: PropTypes.bool,
  hidden: PropTypes.bool,
  onToggleExpand: PropTypes.func,
};

export default function StateOfChargeChart({
  site,
  startDate,
  endDate,
  series = [],
  loading = false,
  hasData = false,
  hidden = false,
  onToggleExpand,
}) {
  if (hidden) return null;

  if (loading) {
    return (
      <Box sx={{ minHeight: 320 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.paper',
            boxShadow: 1,
          }}
        >
          <Skeleton variant="text" width="50%" height={32} />
          <Skeleton variant="text" width="20%" height={24} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={242} sx={{ borderRadius: 2 }} />
        </Box>
      </Box>
    );
  }

  if (!hasData) {
    return (
      <Box sx={{ minHeight: 320, textAlign: 'center', pt: 5 }}>
        <Typography variant="body2">No state of charge data available.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <AppChartCard
        sx={{ height: '100%' }}
        title="State of Charge"
        subheader="SOC %"
        chartData={series}
        xMinMs={startDate?.valueOf()}
        xMaxMs={endDate?.valueOf()}
        expandContractChart={onToggleExpand}
        yAxisMin={0}
        yAxisMax={100}
      />
    </Box>
  );
}